import { FormInstance, Rule } from "antd/es/form";
export const emailRules: Rule[] = [
  {
    validator: (_, value) => {
      if (!value || value.trim().length === 0) {
        return Promise.reject("Vui lòng nhập email!");
      }

      // Hàm kiểm tra định dạng email
      const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      if (!isValid) {
        return Promise.reject("Email không hợp lệ");
      }

      return Promise.resolve();
    },
  },
];
export const passwordRules: Rule[] = [
  {
    validator: (_, value) => {
      if (!value) {
        return Promise.reject(new Error("Vui lòng nhập mật khẩu!"));
      }
      return Promise.resolve();
    },
  },
  {
    validator: (_, value) => {
      if (value && !/^\S(.*\S)?$/.test(value)) {
        return Promise.reject(
          new Error("Mật khẩu không được có khoảng trắng ở đầu hoặc cuối!")
        );
      }
      return Promise.resolve();
    },
  },
];
export const passNewRules = (email: string | undefined): Rule[] => [
  { required: true, message: "Vui lòng nhập mật khẩu mới" },
  {
    validator: (_, value) => {
      if (!value) return Promise.resolve();
      const emailUsernamePart = email?.split("@")[0] || "";
      const usernameAtPattern = new RegExp(`${emailUsernamePart}@`, "i");
      if (
        (value.length < 8 && value.length > 0) ||
        usernameAtPattern.test(value)
      ) {
        return Promise.reject(new Error("Mật khẩu không hợp lệ"));
      } else if (value.length > 32) {
        return Promise.reject(
          new Error("Mật khẩu không được vượt quá 32 ký tự")
        );
      }
      if (!/[A-Z]/.test(value) || !/[a-z]/.test(value)) {
        return Promise.reject(
          new Error("Mật khẩu phải chứa ít nhất 1 chữ hoa, 1 chữ thường")
        );
      }
      if (!/[0-9]/.test(value) || !/[@#]/.test(value)) {
        return Promise.reject(
          new Error(
            "Mật khẩu phải chứa ít nhất 1 số, 1 ký tự đặc biệt (@ hoặc #)"
          )
        );
      }
      return Promise.resolve();
    },
  },
];

export const confirmPasswordRules = (
  getFieldValue: (field: string) => string | undefined
): Rule[] => [
  { required: true, message: "Vui lòng xác nhận mật khẩu" },
  {
    validator: (_, value) => {
      if (!value || getFieldValue("password") === value) {
        return Promise.resolve();
      }
      return Promise.reject(new Error("Mật khẩu không khớp, vui lòng thử lại"));
    },
  },
];

export const productNameRules: Rule[] = [
  {
    required: true,
    message: "Giá trị này là bắt buộc, bạn phải nhập giá trị!",
  },
  {
    max: 100,
    type: "string",
    message: "Tên sản phẩm không được vượt quá 100 ký tự!",
  },
];
export const categoryRules: Rule[] = [
  {
    required: true,
    message: "Giá trị này là bắt buộc, bạn phải chọn giá trị!",
  },
];
export const describeProductRules: Rule[] = [
  {
    required: true,
    message: "Giá trị này là bắt buộc, bạn phải chọn giá trị!",
  },
];
export const minRules = (form: FormInstance): Rule[] => [
  {
    required: true,
    message: "Giá trị nhỏ nhất là bắt buộc, bạn phải nhập giá trị!",
  },
  {
    pattern: /^[0-9]+(\.[0-9]+)?$/,
    message: "Giá trị phải là một số hợp lệ!",
  },
  {
    validator(_, value) {
      if (!value) return Promise.resolve();
      const maxValue = form.getFieldValue("max");
      if (maxValue !== undefined && value > maxValue) {
        return Promise.reject(
          new Error("Giá trị nhỏ nhất không được lớn hơn giá trị lớn nhất")
        );
      }
      return Promise.resolve();
    },
  },
];

export const maxRules = (form: FormInstance): Rule[] => [
  {
    required: true,
    message: "Giá trị lớn nhất là bắt buộc, bạn phải nhập giá trị!",
  },
  {
    pattern: /^[0-9]+(\.[0-9]+)?$/,
    message: "Giá trị phải là một số hợp lệ!",
  },
  {
    validator(_, value) {
      if (!value) return Promise.resolve();
      const minValue = form.getFieldValue("min");
      if (minValue !== undefined && value < minValue) {
        return Promise.reject(
          new Error("Giá trị lớn nhất không được nhỏ hơn giá trị nhỏ nhất")
        );
      }
      return Promise.resolve();
    },
  },
];

export const costPriceRules: Rule[] = [
  {
    required: true,
    message: "Giá trị này là bắt buộc, bạn phải nhập giá trị!",
  },
  {
    pattern: /^[0-9]+(\.[0-9]+)?$/,
    message: "Giá trị phải là một số hợp lệ!",
  },
];

export const salePriceRules: Rule[] = [
  {
    required: true,
    message: "Giá trị này là bắt buộc, bạn phải nhập giá trị!",
  },
  {
    pattern: /^[0-9]+(\.[0-9]+)?$/,
    message: "Giá trị phải là một số hợp lệ!",
  },
];
export const currencyRules: Rule[] = [
  {
    validator: (_, value) => {
      if (!value || value.trim().length === 0) {
        return Promise.reject(
          "Giá trị không được để trống hoặc chỉ chứa khoảng trắng"
        );
      }

      return Promise.resolve();
    },
  },
];
export const currencyOnQuantityRules: Rule[] = [
  {
    required: true,
    message: "Giá trị này là bắt buộc, bạn phải nhập giá trị!",
  },
];
export const userName: Rule[] = [
  { required: true, message: "Vui lòng nhập họ tên !" },
];
export const phoneNumber: Rule[] = [
  {
    validator: (_, value) => {
      if (!value) {
        return Promise.reject("Vui lòng nhập số điện thoại !");
      }

      const cleanValue = String(value).trim();

      if (cleanValue.length === 0) {
        return Promise.reject("Giá trị không được chỉ chứa khoảng trắng");
      }

      if (!/^0\d{9}$/.test(cleanValue)) {
        return Promise.reject(
          "Số điện thoại phải gồm 10 chữ số và bắt đầu bằng số 0"
        );
      }

      return Promise.resolve();
    },
  },
];
export const customAmountRule = (total: number): Rule[] => [
  {
    required: true,
    message: "Vui lòng nhập số tiền thanh toán",
  },
  {
    validator: (_, value) => {
      const numericValue = parseFloat(value?.toString().replace(/,/g, ""));

      if (isNaN(numericValue)) {
        return Promise.reject(new Error("Số tiền không hợp lệ"));
      }

      if (numericValue <= 0) {
        return Promise.reject(new Error("Số tiền phải lớn hơn 0"));
      }

      if (numericValue > total) {
        return Promise.reject(
          new Error("Số tiền phải nhỏ hơn hoặc bằng tổng tiền")
        );
      }

      return Promise.resolve();
    },
  },
];
export const phoneNumberRule = (): Rule => ({
  pattern: /^(0|\+84)[0-9]{9,10}$/,
  message: "Số điện thoại không hợp lệ.",
});

export const CustomerRules: Rule[] = [
  {
    required: true,
    message: "Giá trị này là bắt buộc, bạn phải nhập giá trị!",
  },
];

export const checkAccountNumber = (): Rule[] => [
  {
    validator: (_, value) => {
      if (!value || value.trim() === "") {
        return Promise.reject(new Error("Vui lòng nhập số tài khoản"));
      }

      // Kiểm tra có khoảng trắng
      if (/\s/.test(value)) {
        return Promise.reject(
          new Error("Số tài khoản không được chứa khoảng trắng")
        );
      }

      // Kiểm tra định dạng 8–16 chữ số
      const regex = /^[0-9]{8,16}$/;
      if (!regex.test(value)) {
        return Promise.reject(
          new Error("Số tài khoản phải từ 8–16 chữ số và chỉ chứa số")
        );
      }

      return Promise.resolve();
    },
  },
];

export const isUUID = (value?: string | null): boolean => {
  if (!value) return false;
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(value);
};

export const onlyStringRule = (message?: string): Rule => ({
  pattern:
    /^[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵýỷỹ\s]+$/,
  message: message || "Vui lòng chỉ nhập chữ cái",
});

export const onlyNumberRule = (message?: string): Rule => ({
  pattern: /^[0-9]+$/,
  message: message || "Vui lòng chỉ nhập chữ số!",
});
